import React, { useContext } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import { ForwardItem, MessageNotif, TaskSquare } from 'iconsax-reactjs';

import UserContext from '../../user-context';
import InformationRequest from './components/InformationRequest';
import ProgramRegister from './components/ProgramRegister';
import {
  BadgeStyled,
  ButtonGroupStyled,
  CardTextStyled,
  ContentWrapperStyled,
  DarkCardStyled,
  DarkCardTextStyled,
  IconCardStyled,
  IconWrapperStyled,
  MobilityCoachStyled,
  NetworkStyled,
  PrimaryCardStyled,
  PrimaryCardTextStyled,
  PrimaryCardTitleStyled,
  RectangleImageStyled,
  RocketImageStyled,
  SectionTitleStyled,
  SubtitleStyled,
  TitleStyled,
} from './styles';

const MobilityCoach = React.memo(() => {
  const { user } = useContext(UserContext);

  return (
    <MobilityCoachStyled>
      <ContentWrapperStyled spacing={7}>
        <Stack spacing={8}>
          <BadgeStyled>
            <Typography variant="md" color="primary.main">
              KINT lance l&apos;OUTPLACEMENT 5.0
            </Typography>
          </BadgeStyled>

          <Stack spacing={3}>
            <Stack spacing={4.5}>
              <Stack spacing={1}>
                <TitleStyled>Mon Coach</TitleStyled>
                <TitleStyled sx={{ color: 'primary.main' }}>Mobilité</TitleStyled>
              </Stack>

              <Stack spacing={1}>
                <SubtitleStyled>
                  Vous souhaitez vous repositionner professionnellement ?
                </SubtitleStyled>
                <SubtitleStyled>trouver un nouveau poste ou une nouvelle mission ?</SubtitleStyled>
                <SubtitleStyled>
                  Avec mon coach mobilité, kint vous accompagne au quotidien pour rebondir
                </SubtitleStyled>
              </Stack>
            </Stack>

            {user?.is_coaching_paid === false && (
              <ButtonGroupStyled>
                <InformationRequest />

                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  href="https://app.moncoachmobilite.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  endIcon={<ForwardItem size={16} />}
                >
                  Je me connecte
                </Button>
              </ButtonGroupStyled>
            )}
          </Stack>
        </Stack>

        <Stack spacing={4}>
          <SectionTitleStyled variant="h1">Pourquoi choisir notre méthode ?</SectionTitleStyled>

          <PrimaryCardStyled>
            <Stack spacing={1.5}>
              <PrimaryCardTitleStyled>Un Programme Hybride & Complet</PrimaryCardTitleStyled>
              <PrimaryCardTextStyled>
                Ce programme de 4 mois, conçu par des experts RH, allie une application digitale de
                coaching à des ateliers collectifs organisés tous les 15 jours par les consultants
                KINT.
              </PrimaryCardTextStyled>
            </Stack>
            <RocketImageStyled src={require('../../assets/images/rocket.png')} alt="Rocket" />
          </PrimaryCardStyled>

          <Stack direction="row" spacing={2.5}>
            <IconCardStyled>
              <IconWrapperStyled>
                <TaskSquare size={32} />
              </IconWrapperStyled>

              <Typography variant="h2">Coach digital personnel</Typography>

              <CardTextStyled>
                L&apos;application Mon coach Mobilité constitue un véritable « coach digital
                personnel », qui vous apporte cadre et méthode sous la forme d&apos;un programme
                hebdomadaire d&apos;actions à réaliser. Chaque lundi vous découvrez ainsi une
                nouvelle « To do list » et des conseils pour y parvenir.
              </CardTextStyled>
            </IconCardStyled>

            <IconCardStyled>
              <IconWrapperStyled>
                <MessageNotif size={32} />
              </IconWrapperStyled>

              <Typography variant="h2">Approche à 360°</Typography>

              <CardTextStyled>
                Mon coach Mobilité KINT est un programme à 360° qui vous permet de travailler votre
                projet professionnel, mais aussi d&apos;optimiser votre organisation en tenant
                compte de votre vie personnelle, d&apos;améliorer votre communication écrite et
                orale, et évidemment de développer et activer votre réseau !
              </CardTextStyled>
            </IconCardStyled>
          </Stack>

          <NetworkStyled>
            <Typography variant="h2">Networking</Typography>

            <CardTextStyled>
              Les ateliers collectifs réunissent tous les 15 jours 6 à 10 participants autour
              d&apos;un consultant KINT et d&apos;éventuels intervenants. Ils constituent le
              complément indispensable à l&apos;appli, pour échanger bonnes pratiques et contacts,
              et lancer votre démarche de networking !
            </CardTextStyled>
          </NetworkStyled>

          <DarkCardStyled>
            <Typography variant="h2">Ateliers Collectifs</Typography>

            <DarkCardTextStyled>
              Vous souhaitez en savoir plus : participez à une réunion d&apos;information ! Nous
              serons ravis de vous rencontrer et de vous présenter le programme Mon coach Mobilité
              KINT.
            </DarkCardTextStyled>

            <RectangleImageStyled
              src={require('../../assets/images/rectangle.png')}
              alt="Rectangle"
            />

            {user?.is_coaching_paid === false && (
              <Box>
                <ProgramRegister />
              </Box>
            )}
          </DarkCardStyled>
        </Stack>
      </ContentWrapperStyled>
    </MobilityCoachStyled>
  );
});

export default MobilityCoach;
